import { Json }	from "ts-base/json";

export namespace JsonReflect {
	export const isJson	= (input:unknown):input is Json	=>
		isJsonScalar(input)		||
		isJsonArray(input)		||
		isJsonObject(input);

	export const isJsonScalar	= (input:unknown):input is Json.Scalar	=>
		isJsonString(input)		||
		isJsonNumber(input)		||
		isJsonBoolean(input)	||
		isJsonNull(input);

	export const isJsonString	= (it:unknown):it is string		=>
		typeof it === "string";

	// TODO json have a branded type for numbers without NaN and Infinity
	export const isJsonNumber	= (it:unknown):it is number		=>
		typeof it === "number" && Number.isFinite(it);

	export const isJsonBoolean	= (it:unknown):it is boolean	=>
		typeof it === "boolean";

	export const isJsonNull		= (it:unknown):it is null		=>
		it === null;

	export const isJsonArray	= (input:unknown):input is Json.Array	=>
		isBaseArray(input) && input.every(isJson);

	export const isJsonObject	= (input:unknown):input is Json.Object	=>
		isBaseObject(input) && Object.values(input).every(isJson);

	//-----------------------------------------------------------------------------

	export type BaseArray	= ReadonlyArray<unknown>;
	export type BaseObject	= Readonly<Record<string, unknown>>;

	/** accepts array literals, but not arrays with any other prototype */
	export const isBaseArray	= (it:unknown):it is BaseArray	=>
		Array.isArray(it) && Reflect.getPrototypeOf(it) === arrayPrototype;

	/** accepts (json) literals, but not objects with any other prototype */
	export const isBaseObject	= (it:unknown):it is BaseObject	=>
		it !== null && typeof it === "object" && Reflect.getPrototypeOf(it) === objectPrototype;

	const objectPrototype	= Reflect.getPrototypeOf({});
	const arrayPrototype	= Reflect.getPrototypeOf([]);
}
